<template>
  <!-- 项目详情 -->
  <div class="projectDetail">
     <!-- <div class="title">
        <div class="return" @click="$router.go(-1)"><返回</div>
       <h3>项目详情：{{project.title}}</h3>
     </div> -->
      <mt-header :title="'项目详情：'+ project.title">
          <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
      </mt-header>
     <div class="content">
       <div class="bg_img " :class="{'zhaomu':project.status==4,'close':project.status==5,'jinxing':project.status==7,'over':project.status==8,'hezuo':project.status==6,'pingjia':project.status==9}"></div>
       <h4>{{project.title}}</h4>
       <span class="type">{{project.projectChildTypeName}}</span>
       <!-- <span class="company">{{project.companyName}}</span> -->
       <p class='time'>{{project.releaseTime}}</p>
       <div class="cycle">
         <div class="money">
           <span>项目预算</span>
           <p>{{project.prepriceName}}</p>
         </div>
         <div class="time">
           <span>时间周期</span>
           <p><span>{{project.periodName}}</span></p>
         </div>
       </div>
       <div class="skills">
          <span v-for='(skills,index) in project.skillsList' :key="index">{{skills}}</span>
       </div>
       <div class="path">
         <p><icon name="suitcase"></icon> {{project.industryName}}</p>
         <p><icon name="map-marker"></icon> {{project.cityName}}</p>
         <p v-if="project.enterType == 0"><icon name="cogs"></icon> 接单倾向  无</p>
         <p v-else-if="project.enterType == 1"><icon name="cogs"></icon> 接单倾向  个人</p>
         <p v-else><icon name="cogs"></icon> 接单倾向  团队工作室</p>
       </div>
       <div class="describe">
         <p>项目描述</p>
         <pre>
           {{project.description}}
         </pre>
       </div>
       <div class="img_describe">
         <img  v-for="(photoList,index) in photoList" :key="index" v-lazy="photoList.fullPath" >
       </div>
       <div class="people">
         <div class="recommend">
           <p>已推荐 {{project.countRecommender}} 人</p>
           <div v-if="project.countRecommender != 0 ">
             <span v-for="(recommend,index) in recommendExpertList" :key="index">
               <img :src="httpUrl+recommend.photo" v-if="recommend.photo">
               {{recommend.account.name}}
             </span>
           </div>
         </div>
         <div class="apply">
           <p>已申请 {{project.countOffer}} 人</p>
           <div v-if="project.countOffer != 0 ">
            <span v-for="(apply,index) in applyExpertList" :key="index">
               <img :src="httpUrl+apply.photo" v-if="apply.photo">
               {{apply.account.name}}
            </span>
           </div>
         </div>
         <div class="look">
           <p>已浏览 {{project.countVisit}} 人</p>
         </div>
       </div>
     </div>
     <div>
     <div class="send_btn">
       <span v-if ="project.status == 4 && applyflag" @click="saveprojectoff">发送申请意向</span>
       <!-- <span v-else >发送申请意向</span> -->
     </div>
     </div>
  </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
export default {
  name: 'projectDetail',
  data () {
    // 创建参数区
    return {
      projectid: '',
      accountid: '',
      projectType: '',
      accountType: '',
      project: '',
      photo: '',
      httpUrl: '',
      photoList: '',
      applyExpertList: '',
      recommendExpertList: '',
      applyflag:true
    }
  },
  mounted () {
    // 初始化加载区
    this.projectData()
    this.STATE.state.bottomindex='btnTwo'
  },
  methods: {
    // 方法区
    // 获取项目详情数据
    projectData: function () {
      this.projectid = this.$route.query.projectid
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/work/project/queryweixinproject?id=' + this.projectid + '')
      .then(function (res) {
        if(res.data.createUser==Number(_this.STATE.state.loginId)){
          _this.applyflag=false
        }else{
           _this.applyflag=true
        }
        Indicator.close()
        _this.project = res.data
        _this.photo = res.data.photo
        _this.projectPhoto(_this.photo)
        _this.applyExpert(_this.projectid)
        _this.recommendExpert(_this.projectid)
      }).catch(function (response) {
        Indicator.close()
      })
      // console.log(this.$route.query.projectid)
    },
    // 获取照片
    projectPhoto: function (photo) {
      let _this = this
      this.axios.get('url/common/getphoto?resid=' + photo + '')
      .then(function (res) {
        _this.photoList = res.data.data
        _this.httpUrl = res.data.msg
        // console.log(_this.photoList)
        // console.log(_this.httpUrl)
      })
    },
    // 申请专家
    applyExpert: function (projectid) {
      let _this = this
      this.axios.get('url/work/project/weixinapplyExpert?projectId=' + this.projectid + '&rows=' + 10 + '&page=' + 1 + ' ')
      .then(function (res) {
        _this.applyExpertList = res.data.data
        // console.log(res)
      })
    },
    // 推荐专家
    recommendExpert: function (projectid) {
      let _this = this
      this.axios.get('url/work/project/weixinrecommendExpert?projectId=' + this.projectid + '&rows=' + 10 + '&page=' + 1 + ' ')
      .then(function (res) {
        _this.recommendExpertList = res.data.data
        // console.log(_this.recommendExpertList)
      })
    },
    // 发送申请意向按钮逻辑
    saveprojectoff () {
      let _this = this
      // console.log(sessionStorage.getItem('loginState'))
      if (sessionStorage.getItem('loginState')==='false'||sessionStorage.getItem('loginState')===null) {
        Indicator.close()
        this.$router.push({name: 'login', params: {fromPath: '/project/projectDetail', projectId: this.projectid}})
      } else {
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        this.axios({
          method: 'get',
          url: 'url/account/userInfo/getUserInformationById',
          params: {
            id:sessionStorage.getItem('loginId'),
            rememberMe: true
          }
        }).then(function (res) {
          Indicator.close()
          // console.log(res.data.accountCertificate)
          _this.accountType = res.data.account.status

          if(res.data.accountCertificate.status == '4' && res.data.account.status == '4'){//4:老用户未认证 4:审核通过
            _this.$router.push({path: '/project/projectApplyPopup', query: { projectid: _this.projectid }})

          }else if(res.data.accountCertificate.status == '5' && res.data.account.status == '4'){//5:老用户认证失败 4:审核通过
            _this.$router.push({path: '/project/projectApplyPopup', query: { projectid: _this.projectid }})

          }else{
            if(res.data.accountCertificate.status === 1 && res.data.account.status == '4'){//4:通过平台审核和1:实名认证成功(新老用户)
              _this.$router.push({path: '/project/projectApplyPopup', query: { projectid: _this.projectid }})

            //  if (_this.accountType === 5) {
              //   Toast({
              //     message: '您的账号已冻结，无法使用',
              //     position: 'middle',
              //     duration: 1000
              //   })
              // } else if (_this.accountType === 1) {
              //   Toast({
              //     // 提示
              //     message: '您的账号已注销，无法使用',
              //     // 提示位置
              //     position: 'middle',
              //     // 提示存在时间
              //     duration: 1000
            //   })

            } else {//未通过平台审核和实名认证(新老用户)

              MessageBox.confirm('', {
                title: '您需要完成资质认证，即可申请项目',
                // message: '你需要先完善个人主页信息，提交并通过审核后，再来申请项目',
                showCancelButton: true,
                confirmButtonText: '去认证',
                cancelButtonText: '取消'
              }).then(action => {
                // 绑定确定事件
                if (action === 'confirm') {
                  _this.$router.push({path: '/certification'})
                }
              }).catch(function (response) {
                Indicator.close()
              })
            }
          }

        })
      }
    }
  }
}
</script>


<style scoped>
.projectDetail{
  overflow: hidden;
}
.title{
  width:100%;
  line-height:50px;
  background-color:#108ee9;
  padding:0 14px;
  text-align:center;
  overflow:hidden;
}
 .title .return{
     color:#fff;
     float:left;
 }
 .title h3{
      color:#fff;
      display:inline-block;
      width:auto;
      position:absolute;
      right:70px;
      left:70px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
 }
 .content{
   padding:15px;
 }
 .content h4{
     font-size:14px;
     color:#727272;
     overflow:hidden;
     text-overflow:ellipsis;
     white-space:nowrap;
 }
 .content .type{
       display:inline-block;
       font-size:12px;
       background-color:#e9fafd;
       color:#108ee9;
       padding:3px 5px;
       -webkit-border-radiu:12px;
       -moz-border-radiu:12px;
       border-radius:12px;
       margin:5px 0;
 }
   .content .company{
     font-size:12px;
     color:#727272;
     margin-left:15px;
   }
   .content .time{
     font-size:12px;
     color:#727272;
   }
 .content .cycle{
     overflow:hidden;
   }
   .cycle .money,.cycle .time{
     float:left;
   }
   .cycle .time{
     margin-left:35px;
   }
   .cycle .money span,.cycle .time span,.cycle .time p{
     color:#727272;
     font-size:12px;
   }
   .cycle .money p{
     font-size:18px;
   }
   .cycle .time p span{
     font-size:18px;
     color:#000;
   }
 .content .skills{
     max-height:60px;
     overflow:hidden;
 }
   .content .skills span{
     display:inline-block;
     font-size:12px;
     padding:3px 5px;
     background-color:#f2f2f2;
     color:#a6a6a6;
     -webkit-border-radiu:5px;
     -moz-border-radiu:5px;
     border-radius:5px;
     margin:3px 10px;
   }
 .content .path{
     margin-top:5px;
 }
   .content .path p{
     font-size:12px;
     color:#727272;
   }
   .content .path p .fa-icon{
     color:#cecece;
     width:10px;
     height:10px;
     margin-right:20px;
   }
 .content .describe{
     margin-top:10px;
 }
   .content .describe p{
     font-size:14px;
     color:#727272;
   }
   .content .describe pre{
     font-size:14px;
     white-space: pre-wrap;
     word-wrap: break-word;
   }
 .content .img_describe{
    margin-top:10px;
 }
 .content .img_describe p{
   font-size:14px;
   color:#727272;
 }
 .content .img_describe img{
   display:block;
   max-width:100%;
   height:auto;
   margin:0 auto;
 }
 .content .people{
   margin-top:17px;
 }
 .people .recommend,.people .apply,.people .look{
   margin-bottom:10px;
   display:table;
   width:100%;
 }
 .people .recommend p,.people .apply p,.people .look p{
   font-size:12px;
   color:#727272;
   vertical-align:middle;
   display:table-cell;
   width:80px;
 }
 .people .recommend div,.people .apply div,.people .look div{
   display:inline-block;
   margin-right:5px;
   vertical-align:middle;
   height:27px;
   overflow:hidden;
 }
 .people .recommend div img,.people .apply div img,.people .look div img{
   width:27px;
   height:27px;
   -webkit-border-radiu:50%;
   -moz-border-radiu:50%;
   border-radius:50%;
   margin:0 10px;
   vertical-align:middle;
 }
 .people .recommend div span,.people .apply div span,.people .look div span{
   display:inline-block;
   font-size:12px;
   color:#727272;
   margin-right:8px;
 }
 .send_btn{
   margin-bottom:70px;
   line-height:50px;
   text-align:center;
   background-color:#108ee9;
   color:#fff;
 }
 .content .bg_img{
     width:44px;
     height:44px;
     float:right;
     margin-right:-15px;
     margin-top:-15px;
     background-size:100% 100%;
   }
   .content .zhaomu{
     background-image:url('../assets/img/main_app/state-4.png');
   }
   .content .close{
     background-image:url('../assets/img/main_app/state-5.png');
   }
   .content .jinxing{
     background-image:url('../assets/img/main_app/state-7.png');
   }
   .content .over{
     background-image:url('../assets/img/main_app/state-8.png');
   }
   .content .hezuo{
     background-image:url('../assets/img/main_app/state-6.png');
   }
   .content .pingjia{
     background-image:url('../assets/img/main_app/state-9.png');
   }
</style>



// WEBPACK FOOTER //
// projectDetail.vue?b59ce72c